var _circle, _circle2, _path, _path2, _circle3, _path3, _path4, _path5, _path6, _circle4, _path7, _path8, _circle5, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle6, _circle7, _circle8, _circle9, _circle0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImage3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 250,
    viewBox: "0 0 360 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173.163,
    cy: 127.532,
    r: 71,
    fill: "#EFEFFD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.2126,
    cy: 80.2126,
    r: 71.5229,
    transform: "matrix(1 0 0 -1 93 211.163)",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.227 117.421C166.652 120.868 162.063 125.923 156.513 125.107C153.213 124.621 149.699 124.36 146.053 124.36C142.409 124.36 138.897 124.621 135.598 125.106C130.049 125.921 125.46 120.867 129.885 117.42C134.22 114.043 139.872 112 146.055 112C152.239 112 157.892 114.043 162.227 117.421ZM146.178 156.495C146.136 156.496 146.094 156.496 146.053 156.496C146.014 156.496 145.975 156.496 145.936 156.495C145.976 156.496 146.016 156.496 146.055 156.496C146.096 156.496 146.137 156.496 146.178 156.495Z",
    fill: "#A0A6C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.116 117.421C220.541 120.868 215.951 125.923 210.402 125.107C207.101 124.621 203.587 124.36 199.942 124.36C196.298 124.36 192.785 124.621 189.487 125.106C183.937 125.921 179.349 120.867 183.774 117.42C188.108 114.043 193.761 112 199.944 112C206.128 112 211.781 114.043 216.116 117.421ZM200.066 156.495C200.025 156.496 199.983 156.496 199.942 156.496C199.903 156.496 199.864 156.496 199.825 156.495C199.864 156.496 199.904 156.496 199.944 156.496C199.985 156.496 200.025 156.496 200.066 156.495Z",
    fill: "#A0A6C3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3688,
    cy: 13.3688,
    r: 8.6897,
    transform: "matrix(1 0 0 -1 159.844 50.7373)",
    fill: "#A0A6C4",
    stroke: "#A0A6C4",
    strokeWidth: 9.35814
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.213 30.6846C173.213 57.4221 173.213 64.1065 173.213 64.1065",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253.426 144.319C253.426 122.929 253.426 117.582 253.426 117.582",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93 144.319C93 122.929 93 117.582 93 117.582",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.476 157.688C150.368 165.476 160.869 171.057 173.213 171.057C185.557 171.057 196.059 165.476 199.951 157.688",
    stroke: "#A0A6C4",
    strokeWidth: 17.3794,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 75,
    r: 6,
    fill: "#DEDEF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M265 190C265.4 191.2 275.5 200.833 280.5 205.5L289 225L323.5 235L338 247L356.5 230L345.5 220.5L339.5 205.5L345.5 182L330 176.5L300 158.5L289 155.5V166L277.5 167.5L265 173C264.833 178.167 264.6 188.8 265 190Z",
    fill: "url(#paint0_linear_302_12006)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8074 179.787C80.4585 180.823 71.6491 189.14 67.2881 193.169L59.8744 210.005L29.783 218.639L17.1359 229L1 214.322L10.5943 206.12L15.8276 193.169L10.5943 172.88L24.1136 168.131L50.28 152.59L59.8744 150V159.066L69.9048 160.361L80.8074 165.109C80.9527 169.57 81.1562 178.751 80.8074 179.787Z",
    fill: "url(#paint1_linear_302_12006)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 214,
    r: 6,
    fill: "#DEDEF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4141 138.765L53.8572 127.343",
    stroke: "#A0A6C3",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0859 141.318L37.6688 127.771",
    stroke: "#A0A6C3",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.585 147.724L25.8859 139.892",
    stroke: "#A0A6C3",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 213.5C6.05083 211.586 8.62048 209.4 10.7437 207.496C13.6005 204.935 15.6072 201.591 16.7705 197.935L16.8361 197.729C17.9312 194.287 19.7891 191.137 22.2711 188.513L34.0447 176.067C35.2145 174.83 37.0405 174.472 38.5903 175.177L39.1102 175.413C40.5067 176.048 41.2752 177.567 40.9592 179.068V179.068C40.3842 181.8 43.2718 183.952 45.725 182.62L52.7856 178.787C55.325 177.409 58.4509 177.735 60.6504 179.609L63.9673 182.435C67.9462 185.824 69.5784 191.225 68.1425 196.251L67.3204 199.128C65.5725 205.246 60.7225 209.985 54.5659 211.591L35.4443 216.579C31.8633 217.513 28.5469 219.263 25.7542 221.692L18.5 228",
    stroke: "#A0A6C3",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.946 173.026C16.057 172.327 19.2971 171.387 22.0143 170.521C25.6702 169.356 28.8715 167.13 31.432 164.272L31.5763 164.111C33.9865 161.421 36.9727 159.309 40.3124 157.934L56.1544 151.41C57.7285 150.762 59.5405 151.185 60.665 152.463L61.0423 152.891C62.0557 154.043 62.1337 155.744 61.2299 156.983V156.983C59.5854 159.239 61.3366 162.386 64.1201 162.177L72.1315 161.577C75.0128 161.361 77.7299 162.94 78.9677 165.551L80.6092 169.014C82.9368 173.923 81.8469 179.772 77.9074 183.514L69.5 191.5",
    stroke: "#A0A6C3",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M335.692 163.544L345.154 153.509",
    stroke: "#A0A6C3",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M325.061 153.196L334.05 137.989",
    stroke: "#A0A6C3",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M312.538 148.149L314.441 134.489",
    stroke: "#A0A6C3",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M356 229.146C352.677 226.654 349.327 223.768 346.69 221.374C343.85 218.794 341.841 215.454 340.678 211.798L339.988 209.629C338.893 206.188 337.035 203.037 334.553 200.414L320.007 185.036C318.628 183.579 316.477 183.157 314.65 183.988L314.038 184.266C312.392 185.014 311.486 186.804 311.859 188.573V188.573C312.537 191.792 309.134 194.328 306.243 192.759L297.923 188.242C294.931 186.618 291.247 187.002 288.655 189.21L284.747 192.54C280.058 196.534 278.135 202.899 279.827 208.821L280.795 212.211C282.855 219.42 288.57 225.005 295.825 226.897L319.329 233.028C322.91 233.963 326.226 235.712 329.019 238.141L338.324 246.233",
    stroke: "#A0A6C3",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M344.869 181.453C340.816 180.542 336.577 179.284 333.191 178.181C329.542 176.993 326.341 174.771 323.781 171.913L322.262 170.218C319.852 167.528 316.866 165.417 313.526 164.041L293.953 155.981C292.098 155.217 289.963 155.716 288.638 157.221L288.193 157.727C286.999 159.084 286.907 161.088 287.972 162.548V162.548C289.91 165.206 287.847 168.915 284.567 168.669L275.126 167.961C271.731 167.707 268.529 169.568 267.071 172.645L265.135 176.728C262.393 182.512 263.675 189.403 268.314 193.814L278.5 203.5",
    stroke: "#A0A6C3",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 6,
    r: 6,
    fill: "#D7D7ED"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 241 50)",
    fill: "#DCDCF0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 62 90)",
    fill: "#E2E2F8"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 241 208)",
    fill: "#E2E2F8"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 285 121)",
    fill: "#E5E5F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_12006",
    x1: 328,
    y1: 216.5,
    x2: 266.067,
    y2: 172.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1F3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_302_12006",
    x1: 25.8581,
    y1: 202.667,
    x2: 79.5015,
    y2: 163.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1F3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage3);
export default __webpack_public_path__ + "static/media/emptyImage3.2774afc7f914839f054370be142fd8c6.svg";
export { ForwardRef as ReactComponent };